import { pageUrl } from '@/constants/url'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { usePermissions } from './usePermissions'

interface UseHavePermissionProps {
  permission: string
  branch?: string
}
export const useHavePermission = (props: UseHavePermissionProps) => {
  const { havePermissionAccess } = usePermissions()
  const navigate = useNavigate()
  useEffect(() => {
    const havePermissions = havePermissionAccess(props)
    if (!havePermissions) navigate(pageUrl.error403)
  }, [props, navigate, havePermissionAccess])
  return null
}
